import { useState, KeyboardEvent, useCallback } from 'react';

interface UseListNavigationProps {
    itemCount: number;
    isOpen: boolean;
    onSelect: (index: number) => void;
    onClose?: () => void;
}

export const useListNavigation = ({
    itemCount,
    isOpen,
    onSelect,
    onClose,
}: UseListNavigationProps) => {
    const [highlightedIndex, setHighlightedIndex] = useState(0);

    const handleKeyDown = useCallback(
        (e: KeyboardEvent<HTMLElement>) => {
            if (!isOpen || itemCount === 0) return;

            const actionMap: Record<string, () => void> = {
                ArrowDown: () => {
                    e.preventDefault();
                    setHighlightedIndex((prev) =>
                        Math.min(prev + 1, itemCount - 1),
                    );
                },
                ArrowUp: () => {
                    e.preventDefault();
                    setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                },
                Enter: () => {
                    e.preventDefault();
                    onSelect(highlightedIndex);
                },
                Escape: () => {
                    e.preventDefault();
                    onClose?.();
                },
            };

            actionMap[e.key]?.();
        },
        [isOpen, itemCount, highlightedIndex, onSelect, onClose],
    );

    return { highlightedIndex, setHighlightedIndex, handleKeyDown };
};
